import React from 'react';
import './style.scss';
import { Button } from '@mui/material';

function OutlinedButton({ children, onClick, className, id, style = {} }) {
    if (children === 'Cancel'||children ==='Back' ||children ==='X') {
        return (
            <Button variant="outlined" className={`button_cancel ${className}`} id={id} onClick={onClick} style={style}>{children}</Button>
        )
    } else {
        return (
            <Button variant="outlined" className={`button ${className}`} id={id} onClick={onClick} style={style}>{children}</Button>
        )
    }

}
export default OutlinedButton;